import script from "./LaputaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaCard.vue?vue&type=script&setup=true&lang=js"

import "./LaputaCard.vue?vue&type=style&index=0&id=4df87b81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df87b81"]])

export default __exports__